function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 12");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Empty-comment-icon-wrapper",
  fill: "#646F77"
}, React.createElement("path", {
  id: "Shape",
  d: "M15.739726,0 C16.9880409,0 18,1.01195913 18,2.26027397 L18,12.369863 C18,13.6181779 16.9880409,14.630137 15.739726,14.630137 L10.6849315,14.630137 L6.43536311,17.82706 C6.28616192,17.9393031 6.10451523,18 5.91780822,18 C5.75893178,18 5.63013699,17.8712052 5.63013699,17.7123288 L5.63013699,14.630137 L2.26027397,14.630137 C1.01195913,14.630137 0,13.6181779 0,12.369863 L0,2.26027397 C0,1.01195913 1.01195913,0 2.26027397,0 L15.739726,0 Z M15.739726,1.68493151 L2.26027397,1.68493151 C1.97429639,1.68493151 1.73705106,1.89357908 1.69246177,2.16695044 L1.68493151,2.26027397 L1.68493151,12.369863 C1.68493151,12.6558406 1.89357908,12.8930859 2.16695044,12.9376752 L2.26027397,12.9452055 L7.31506849,12.9452055 L7.31506849,15.0410959 L10.109589,12.9452055 L15.739726,12.9452055 C16.0257036,12.9452055 16.2629489,12.7365579 16.3075382,12.4631866 L16.3150685,12.369863 L16.3150685,2.26027397 C16.3150685,1.97429639 16.1064209,1.73705106 15.8330496,1.69246177 L15.739726,1.68493151 Z"
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.52054795,
  y: 8.17808219,
  width: 5.5890411,
  height: 1.68493151,
  rx: 0.575342466
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.52054795,
  y: 4.80821918,
  width: 8.95890411,
  height: 1.68493151,
  rx: 0.575342466
})));

var SvgCommentIcon = function SvgCommentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCommentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment-icon.fab11750.svg";
export { ForwardRef as ReactComponent };